//import { TweenMax, TweenLite, TimelineMax, Quart, Expo } from 'gsap';
//import ScrollMagic from 'scrollmagic';

var Animations = {};

//--------------
// Variables
//--------------
// Animations.$menu = $('.js-menu');
Animations.width = null;

//--------------
// Functions
//--------------


/**
 * Fade to Top
 * @return {void}
 */
Animations.fadeToTop = function(element, opDuration, yDuration, yStart, yEnd, triggerElement) {
	var fadedToTop = new TimelineMax();
	var dataDelay = $(element).data('delay');
	var dataOffset = $(element).data('offset');
	var delay = 0;
	var offset = 0.9;
	var triggerElement = (typeof triggerElement == 'undefined') ? element : '#' + $(element).closest('.js-animation-wrapper').attr('id');

	// if data-delay defined
	if(typeof dataDelay !== typeof undefined && dataDelay !== false) delay = dataDelay;

	// if data-offset defined
	if(typeof dataOffset !== typeof undefined && dataOffset !== false) offset = dataOffset;

	// Fade to Top
	fadedToTop.staggerFromTo($(element), opDuration, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.2, delay);
    fadedToTop.staggerFromTo($(element), yDuration, {yPercent: yStart}, {yPercent: yEnd, force3D:true, ease: Quart.easeOut}, 0.2, delay);

    var scene = new ScrollMagic.Scene({
		triggerElement: triggerElement,
		triggerHook: offset,
		reverse: false
	})
	.setTween(fadedToTop)
	// .addIndicators({name: "fadeToTop"})
	.addTo(App.animationsController);
}

/**
 * Fade to Right
 * @return {void}
 */
Animations.fadeHorizontally = function(element, opDuration, xDuration, xStart, xEnd) {
	Animations.fadedHorizontally = new TimelineMax();
	var dataDelay = $(element).data('delay');
	var dataOffset = $(element).data('offset');
	var delay = 0;
	var offset = 0.85;

	// if data-delay defined
	if(typeof dataDelay !== typeof undefined && dataDelay !== false) delay = dataDelay;

	// if data-offset defined
	if(typeof dataOffset !== typeof undefined && dataOffset !== false) offset = dataOffset;


	// Fade Horizontally
	Animations.fadedHorizontally.fromTo($(element), opDuration, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.075, delay);
  Animations.fadedHorizontally.fromTo($(element), xDuration, {xPercent: xStart}, {xPercent: xEnd, force3D:true, ease: Quart.easeOut}, 0.075, delay);

  Animations.sceneHorizontally = new ScrollMagic.Scene({
		triggerElement: element,
		triggerHook: offset,
		reverse: false
	})
	.setTween(Animations.fadedHorizontally)
	// .addIndicators({name: "fade to right"})
	.addTo(App.animationsController);
}

/**
 * Fadein (series)
 * @return {void}
 */
Animations.fadein = function(element, triggerElement, direction, duration, start, end, delay, offset) {
	var fadein = new TimelineMax();

	// Fade to Top
	if(direction == 'horizontal') {
		fadein.staggerFromTo($(element), duration, {opacity: 0, xPercent: start}, {opacity: 1, xPercent: end, force3D:true, ease: Quart.easeOut}, 0.15, delay);
	}

	if(direction == 'vertical') {
		fadein.staggerFromTo($(element), duration, {opacity: 0, yPercent: start}, {opacity: 1, yPercent: end, force3D:true, ease: Quart.easeOut}, 0.15, delay);
	}

    var scene = new ScrollMagic.Scene({
		triggerElement: element,
		triggerHook: offset,
		reverse: false
	})
	.setTween(fadein)
	.addTo(App.animationsController);
}

/**
 * Fade from Left
 * @return {void}
 */
Animations.fadeFromLeft = function(element) {
	var fadeFromLeft = new TimelineMax();

	// Fade from Left
    fadeFromLeft.fromTo($(element).find('.title'), 1.5, {opacity: 0, xPercent: -100}, {opacity: 1, xPercent: 0, force3D:true, ease: Quart.easeOut}, 0.02, 0);

    new ScrollMagic.Scene({
			triggerElement: element,
			triggerHook: 0.765,
			reverse: false
		})
		.setTween(fadeFromLeft)
		.setClassToggle(element, "is-visible")
		// .addIndicators({name: "fade from left"})
		.addTo(App.animationsController);
}


/**
 * About profile Fadein
 * @return {void}
 */
Animations.profilesFadein = function(){
	var tl = new TimelineMax();

	tl.fromTo('.js-about-profile', 0.8, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0);
    tl.fromTo('.js-about-profile.is-first', 1.8, {y: 80}, {y: 0, force3D:true, ease: Quart.easeOut}, 0.40);
    tl.fromTo('.js-about-profile.is-second', 1.5, {y: 300}, {y: 0, force3D:true, ease: Quart.easeOut}, 0);
}

/**
 * About profile on scroll
 * @return {void}
 */
Animations.profileScroll = function() {
	var profileScroll = new TimelineMax();

	profileScroll.fromTo(".js-about-profile.is-second", 1.5, { y: -25 }, { y: 86 }, 0.02);

	var scene3 = new ScrollMagic.Scene({
	    triggerElement: '.js-animation-wrapper',
	    duration: $(window).height() * 2
	    // triggerHook: 0.7,
	})
	.setTween(profileScroll)
	.addTo(App.animationsController);
}

/**
 * Clients
 * @return {void}
 */
Animations.clients = function() {
	var clients = new TimelineMax();

	clients.staggerFromTo('.js-client', 1.5, {opacity:0}, {opacity:1}, 0.25);

	var scene = new ScrollMagic.Scene({
	    triggerElement: '.js-clients',
	    // duration: $(window).height() * 2
	    triggerHook: 0.7,
	    reverse: false
	})
	.setTween(clients)
	.addTo(App.animationsController);
}

/**
 * Numbers
 * @return {void}
 */
Animations.numbers = function(element) {
	var numbers = new TimelineMax();

	numbers.fromTo($(element), 1.5, {opacity: 0}, {opacity: 0.8}, 0.8);
	numbers.fromTo($(element), 1.5, {xPercent: -50}, {xPercent: 0, ease: Quart.easeOut}, 0.8);

	var scene = new ScrollMagic.Scene({
	    triggerElement: element,
	    triggerHook: 0.7,
	})
	.setTween(numbers)
	.addTo(App.animationsController);
}

/**
 * Projects list
 * @return {void}
 */
Animations.projects = function() {
	var projectsFading = new TimelineMax();
	var projectsScroll = new TimelineMax();

	// Fade to Top
	projectsFading.staggerFromTo('.js-project-thumbnail:nth-child(odd)', 1.2, {opacity: 0, yPercent: -20}, {opacity: 1, yPercent: 0, ease: Quart.easeOut}, 0.25, 0);
	projectsFading.staggerFromTo('.js-project-thumbnail:nth-child(even)', 1.2, {opacity: 0, yPercent: 20}, {opacity: 1, yPercent: 0, ease: Quart.easeOut}, 0.25, 0.25);

    var scene = new ScrollMagic.Scene({
		triggerElement: '.js-projects-list',
		triggerHook: 0.75,
		reverse: false
	})
	.setTween(projectsFading)
	// .addIndicators({name: "projects"})
	.addTo(App.animationsController);


	// Scroll
	projectsScroll.fromTo(".js-project-thumbnail:nth-child(odd)", 1, { yPercent: -6 }, { yPercent: 30 }, 0);
	projectsScroll.fromTo(".js-project-thumbnail:nth-child(even)", 1, { yPercent: 3 }, { yPercent: -20 }, 0);

	var scene2 = new ScrollMagic.Scene({
	    triggerElement: '.js-projects-list',
	    duration: $('.scroll-content').height()
	    // triggerHook: 0.7,
	})
	.setTween(projectsScroll)
	.addTo(App.animationsController);
}

/**
 * Projects list (2 thumbnails)
 * @return {void}
 */
Animations.projectsTwo = function() {
	var projectsTwo = new TimelineMax();

	// Fade to Top
	projectsTwo.staggerFromTo('.js-two-project-thumbnail', 1.2, {opacity: 0, yPercent: 25}, {opacity: 1, yPercent: 0, ease: Quart.easeOut}, 0.25);

    var scene = new ScrollMagic.Scene({
		triggerElement: '.js-projects-list',
		triggerHook: 0.85,
		reverse: false
	})
	.setTween(projectsTwo)
	.addTo(App.animationsController);
}


/**
 * Project Carousel
 * @return {void}
 */
Animations.projectCarousel = function() {
	var projectCarousel = new TimelineMax();

	projectCarousel.fromTo('.js-project-carousel-image-overlay', 1.6, {height: '100%'}, {height: 0, ease: Quart.easeOut}, 0.075);

	projectCarousel.staggerFromTo('.js-project-carousel-text', 1.2, {opacity: 0, xPercent: 20}, {opacity: 1, xPercent: 0, ease: Quart.easeOut}, 0.15, 0.6);

	var scene = new ScrollMagic.Scene({
	    triggerElement: '.js-project-carousel',
	    triggerHook: 0.7,
	    reverse: false
	})
	.setTween(projectCarousel)
	.addTo(App.animationsController);
}


/**
 * Service
 * @return {void}
 */
Animations.service = function() {
	var service = new TimelineMax();

	var scene = new ScrollMagic.Scene({
	    triggerElement: '.service-description.is-plus',
	    triggerHook: 0.7,
	})
	.setTween(service)
	.setClassToggle('.service-description.is-plus', 'is-show')
	.addTo(App.animationsController);
}


/**
 * Contact
 * @return {void}
 */
Animations.contact = function() {
	var contact = new TimelineMax();

	contact.staggerFromTo('.js-contact-animation', 1.2, {opacity: 0, xPercent: 20}, {opacity: 0.8, xPercent: 0, ease: Quart.easeOut}, 0.1, 1.2);

	var scene = new ScrollMagic.Scene({
	    triggerElement: '#js-contact-container',
	    triggerHook: 0.7,
	})
	.setTween(contact)
	.setClassToggle('.js-contact-title', 'is-visible')
	.addTo(App.animationsController);
}


/**
 * 404
 * @return {}
 */
Animations.init404 = function(){
	var tlInit404 = new TimelineMax();

	// Banner image
	tlInit404.fromTo('.js-error404-col-image', 1.2, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.02, 0);
	tlInit404.fromTo('.js-error404-col-image', 1.8, {yPercent: 40}, {yPercent: 0, force3D:true, ease: Quart.easeOut}, 0.02, 0);

    //-- Banner text
	tlInit404.staggerFromTo('.js-error404-text', 1, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.15, 0.6);
	tlInit404.staggerFromTo('.js-error404-text', 1.5, {xPercent: 60}, {xPercent: 0, force3D:true, ease: Quart.easeOut}, 0.15, 0.6);
}


/**
 * Init Events
 * @return {[type]} [description]
 */
Animations.initEvents = function(){
	console.log();
	if(Animations.width >= 768 && $(window).width() < 768){
		Animations.destroyForMobile();
	}

	if(Animations.width < 768 && $(window).width() >= 768){
		Animations.initForTablet();
	}
}

/**
 * Init for Desktop
 * @return {[type]} [description]
 */
Animations.initForDesktop = function(){
	
}

/**
 * Destroy animations for Tablet (and Mobile)
 * @return {[type]} [description]
 */
Animations.destroyForTablet = function(){

}

/**
 * Init Tablet (and Desktop)
 * @return {[type]} [description]
 */
Animations.initForTablet = function(){
	//-- Fade to Top (trigger element = wrapper)
	if($('.js-fade-to-top').length > 0) {	
		$('.js-fade-to-top').each(function(){
		  	Animations.fadeToTop(this, 1.2, 1.8, 60, 0, true);
		});
	}

	//-- Fade to Right
	if($('.js-fade-to-right').length > 0) {	
		$('.js-fade-to-right').each(function(){
		  	Animations.fadeHorizontally(this, 1, 1.5, 100, 0);
		});
	}

	//-- Fade from Left
	if($('.fade-from-left').length > 0) {
		$('.fade-from-left').each(function(){
			Animations.fadeFromLeft(this);
		});
	}

	//-- Service
	if($('.service-description.is-plus').length > 0) {
		Animations.service();
	}

	//-- Projects List
	if($('.js-project-thumbnail').length > 0) {
		Animations.projects();
		setTimeout(function(){
			$('.js-project-thumbnail').addClass('is-scroll');
		},1200);
	}

	//-- Projects List (home)
	if($('.js-two-project-thumbnail').length > 0) {
		Animations.projectsTwo();
	}

	//-- Project Carousel
	if($('.js-project-carousel-image-overlay').length > 0) Animations.projectCarousel();

	//-- About page
	if($('.js-about-profile').length > 0) {
		Animations.profilesFadein();
		Animations.profileScroll();
	}
	if($('.js-clients').length > 0) Animations.clients();

	//-- Numbers
	if($('.js-number-animation').length > 0) {
		$('.js-number-animation').each(function(){
			Animations.numbers(this);
		});
	}

	//-- Contact page
	if($('.js-contact-animation').length > 0) Animations.contact();

	//-- Legal Notice
	if($('.js-legal-section').length > 0) {	
		Animations.fadein('.js-legal-section', '.js-legal-wrapper', 'horizontal', 1.8, 15, 0, 0, 0.85);
	}

	//-- Legal Notice
	if($('.js-error404').length > 0) {	
		Animations.init404();
	}
}

/**
 * Destroy animations for Mobile
 * @return {[type]} [description]
 */
Animations.destroyForMobile = function(){
	//-- Fade to Top
	TweenMax.killTweensOf(".js-fade-to-top:not(.is-background)");﻿
	TweenMax.set(".js-fade-to-top:not(.is-background)", { clearProps: 'all' });
	
	//-- Fade to Right
	TweenMax.killTweensOf(".js-fade-to-right");﻿
	TweenMax.set(".js-fade-to-right", { clearProps: 'all' });
	/*Animations.fadedHorizontally.kill();
	Animations.sceneHorizontally.destroy();
	Animations.sceneHorizontally = null;
	Animations.fadedHorizontally = null;*/

	//-- Fade from Left
	TweenMax.killTweensOf(".fade-from-left");﻿
	TweenMax.set(".fade-from-left", { clearProps: 'all' });
	
	//-- Service
	TweenMax.killTweensOf(".service-description.is-plus");﻿
	TweenMax.set(".service-description.is-plus", { clearProps: 'all' });

	//-- Projects List
	TweenMax.killTweensOf(".js-project-thumbnail");﻿
	TweenMax.set(".js-project-thumbnail", { clearProps: 'all' });

	//-- Projects List (home)
	TweenMax.killTweensOf(".js-two-project-thumbnail");﻿
	TweenMax.set(".js-two-project-thumbnail", { clearProps: 'all' });

	//-- Project Carousel
	TweenMax.killTweensOf(".js-project-carousel-image-overlay");﻿
	TweenMax.set(".js-project-carousel-image-overlay", { clearProps: 'height' });

	//-- About page
	TweenMax.killTweensOf(".js-about-profile");﻿
	TweenMax.set(".js-about-profile", { clearProps: 'height' });
	TweenMax.killTweensOf(".js-client");﻿
	TweenMax.set(".js-client", { clearProps: 'opacity' });

	//-- Numbers
	TweenMax.killTweensOf(".js-number-animation");﻿
	TweenMax.set(".js-number-animation", { clearProps: 'all' });

	//-- Contact page
	TweenMax.killTweensOf(".js-contact-animation");﻿
	TweenMax.set(".js-contact-animation", { clearProps: 'all' });

	//-- Legal Notice
	TweenMax.killTweensOf(".js-legal-section");﻿
	TweenMax.set(".js-legal-section", { clearProps: 'all' });
}


/**
 * Init Animations scripts
 * @return {void}
 */
Animations.init = function(){
	//Animations.initEvents();
	Animations.width = $(window).width();

	if($(window).width() >= 768){
		Animations.initForTablet();
	}

	//-- On resize
	$(window).on('resize', function() {
		Animations.initEvents();
		Animations.width = $(window).width();
	});
}

//--------------
// Execution
//--------------

// Animations.init();

module.exports = Animations;